export default "__VITE_ASSET__CHrqgUM0__"